"use client";

import { EphemeralKeyPair } from "@aptos-labs/ts-sdk/keyless";
import { isServer } from "@decibeltrade/web-core/utils";

import { env } from "@/env";
import { createAndStoreEphemeralKeyPair } from "@/utils/keyless/ephemeral";

export type KeylessProvider = "google" | "apple";

const getGoogleRedirectUrl = (ephemeralKeyPair: EphemeralKeyPair, loginHint?: string) => {
  if (isServer()) return "";
  const redirectUrl = new URL("https://accounts.google.com/o/oauth2/v2/auth");
  const searchParams = new URLSearchParams({
    client_id: env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || "",
    redirect_uri: `${window.location.origin}/auth`,
    response_type: "id_token",
    scope: "openid email profile",
    nonce: ephemeralKeyPair.nonce,
  });
  if (loginHint) {
    searchParams.set("login_hint", loginHint); // avoid showing account chooser if login hint is provided
  } else {
    searchParams.set("prompt", "select_account"); // show account chooser
  }
  redirectUrl.search = searchParams.toString();
  return redirectUrl.toString();
};

const getAppleRedirectUrl = () => {
  // @todo: implement
  return "";
};

const getRedirectUrl = (
  provider: KeylessProvider,
  ephemeralKeyPair: EphemeralKeyPair,
  loginHint?: string,
) => {
  switch (provider) {
    case "google":
      return getGoogleRedirectUrl(ephemeralKeyPair, loginHint);
    case "apple":
      return getAppleRedirectUrl();
  }
};

const getFeatures = () => {
  return {
    width: Math.min(600, window.innerWidth),
    height: Math.min(700, window.innerHeight),
    left: window.screenX + (window.innerWidth - 600) / 2,
    top: window.screenY + (window.innerHeight - 600) / 2,
  };
};

export const openKeylessWindow = (
  provider: KeylessProvider,
  sameWindow?: boolean,
  loginHint?: string,
) => {
  const { width, height, left, top } = getFeatures();

  const ephemeralKeyPair = createAndStoreEphemeralKeyPair();

  const redirectUrl = getRedirectUrl(provider, ephemeralKeyPair, loginHint);

  const windowFeatures = `popup=true,width=${width},height=${height},left=${left},top=${top},noopener,noreferrer`;
  if (sameWindow) {
    window.open(redirectUrl, "_self", windowFeatures);
  } else {
    window.open(redirectUrl, "_blank", windowFeatures);
  }
};
